define(() => {
    "use strict";

    const polyfillStringFunction = () => {
        // Taken from MDN: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith
        if (!String.prototype.startsWith) {
            String.prototype.startsWith = function(searchString, position = 0) {
                return this.substr(position, searchString.length) === searchString;
            };
        }

        // Taken from MDN: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes
        // Always polyfill since the perf are really poor for now.
        String.prototype.includes = function(search, start = 0) {
            if (start + search.length > this.length) {
                return false;
            }
            return this.indexOf(search, start) !== -1;
        };

        // This is ES2016+ So won't be implemented by a lot of browsers.
        // Only firefox has an implementation.
        if (!String.prototype.trimRight) {
            String.prototype.trimRight = function() {
                return this.replace(/ +$/g, "");
            };
        }
    };

    polyfillStringFunction();
});



// WEBPACK FOOTER //
// ./src/shared/util/StringPolyfill.js